<template>
    <div @click="google" class="login-button bg-primary text-white">
        <div class="icon-block bg-white text-dark">
            <font-awesome-icon icon="fa-brands fa-google" />
        </div>
        {{ actionLabel }}
        {{ $t("with Google") }}
        <div class="invisible icon-block">
            <font-awesome-icon icon="fa-duotone fa-envelope" />
        </div>
    </div>
</template>

<script>
/* global FirebasePlugin */

import { mapGetters, mapState } from "vuex";
import { LAST_LOGIN_METHOD } from "@/constant/localStorage";

const GOOGLE_OAUTH_STATE_KEY = "google_oauth_state";
const GOOGLE_OAUTH_REDIRECT_URI_KEY = "google_oauth_redirect_uri";

// Web OAuth 2.0 client ID from Google Cloud Console
const GOOGLE_WEB_CLIENT_ID =
    "25569898344-ca0du3hbvo45kqrknmuikt9q4lcrnt0p.apps.googleusercontent.com";

export default {
    created() {},
    computed: {
        currentMode() {
            return this.$route.meta.mode;
        },
        actionLabel() {
            if (this.currentMode === "signup") {
                return this.$t("Signup");
            }

            return this.$t("Login");
        },
        ...mapState("login", ["method"]),
        ...mapState("system", ["cordova"]),
        ...mapGetters("user", ["isLoggedIn"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        defaultPage() {
            this.$router.push({ name: "defaultPage" });
        },
        setLastLoginMethod(method) {
            localStorage.setItem(LAST_LOGIN_METHOD, method);
        },
        google() {
            if (this.cordova) {
                const googleOauthId =
                    "25569898344-ca0du3hbvo45kqrknmuikt9q4lcrnt0p.apps.googleusercontent.com";

                FirebasePlugin.authenticateUserWithGoogle(
                    googleOauthId,
                    (credential) => {
                        FirebasePlugin.signInWithCredential(
                            credential,
                            () => {
                                this.$store.dispatch(
                                    "appEvent/create",
                                    "login_success_google"
                                );

                                this.loadCurrentUser();

                                this.setLastLoginMethod("google");
                            },
                            (error) => {
                                console.log(1);
                                console.log(error);
                                this.$store.dispatch(
                                    "appEvent/create",
                                    "login_failure_google"
                                );
                            }
                        );
                    },
                    (error) => {
                        console.log(2);
                        console.log(error);
                        this.$store.dispatch(
                            "appEvent/create",
                            "login_failure_google"
                        );
                    }
                );
            } else {
                const redirectUri =
                    window.location.origin + "/auth/google/callback";

                const state = this.generateState();
                sessionStorage.setItem(GOOGLE_OAUTH_STATE_KEY, state);
                sessionStorage.setItem(
                    GOOGLE_OAUTH_REDIRECT_URI_KEY,
                    redirectUri
                );

                const params = new URLSearchParams({
                    client_id: GOOGLE_WEB_CLIENT_ID,
                    redirect_uri: redirectUri,
                    response_type: "code",
                    scope: "openid email profile",
                    state,
                    prompt: "select_account",
                });

                window.location.href =
                    "https://accounts.google.com/o/oauth2/v2/auth?" +
                    params.toString();
            }
        },
        generateState() {
            const array = new Uint8Array(32);
            crypto.getRandomValues(array);
            return Array.from(array, (b) =>
                b.toString(16).padStart(2, "0")
            ).join("");
        },
        loadCurrentUser() {
            FirebasePlugin.reloadCurrentUser(
                (firebaseUser) => {
                    this.loginFromIdToken(firebaseUser.idToken);
                },
                (error) => {
                    this.$store.dispatch(
                        "appEvent/create",
                        "login_reload_user_failure"
                    );
                    console.error(error);
                }
            );
        },
        loginFromIdToken(idToken) {
            this.api
                .post("/firebase/signinWithIdToken", {
                    idToken,
                })
                .then((response) => {
                    if (response?.data?.authToken) {
                        this.$store
                            .dispatch("user/login", response.data.authToken)
                            .then(() => {
                                this.$router.push({ name: "defaultPage" });
                            });
                    }
                });
        },
    },
    components: {},
};
</script>